<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12" md="6">
          <GradeClassSelect @changed="gradeClassChange" />
        </v-col>
        <v-col cols="12" md="3">
          <DateISOPickerMargin
            label="Từ ngày"
            :date.sync="start"
            outlined
            :rules="[$rules.emptyDate, $rules.dateFromNow]"
            dense
          />
        </v-col>
        <v-col cols="12" md="3">
          <DateISOPickerMargin
            label="Đến ngày"
            :date.sync="end"
            outlined
            :rules="[$rules.emptyDate, $rules.dateFromNow]"
            dense
          />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button mb-5" @click="onFilterChanged" outlined :disabled="isButtonDisabled">
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { get } from 'lodash'
import GradeClassSelect from '@/components/basic/filter/GradeClassSelect.vue'
import DateISOPickerMargin from '../../../components/basic/picker/DateISOPickerMargin.vue'

export default {
  components: { DateISOPickerMargin, GradeClassSelect },
  data() {
    return {
      selectedGrade: {},
      selectedClass: null,
      start: moment().startOf('month').toISOString(),
      end: moment().toISOString(),
    }
  },
  computed: {
    isButtonDisabled() {
      return !this.selectedClass || Object.keys(this.selectedClass).length === 0
    },
  },
  mounted() {
    const searchImmediate = !!this.$route.query.searchImmediate
    if (searchImmediate) {
      this.onFilterChanged()
    }
  },
  methods: {
    gradeClassChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
    },

    onFilterChanged() {
      const startTime = moment(this.start)
      const endTime = moment(this.end)
      const startOfDay = startTime.startOf('day').toISOString()
      const endOfDay = endTime.endOf('day').toISOString()

      const params = {
        date_gte: startOfDay,
        date_lte: endOfDay,
        grade: get(this.selectedGrade, '_id', ''),
        class: get(this.selectedClass, '_id', ''),
      }

      this.$emit('onFilterChanged', params, this.selectedClass)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
